import request from "@/utils/request";

/**
 * 登录接口
 * @param {Object} data
 * @param {String} data.username 用户名
 * @param {String} data.password 密码
 * @returns
 */
export const login = (data) => request.post("/apc/login/index", data);

/**
 * 扫码登录
 */
export const scanCodeLoginWithToken = (data) => request.post("/apc/login/tokenLogin", data);

/**
 * 中控携带token跳转登录
 */
export const secretLoginWidthToken = (data) => request.post("/apc/login/secretLogin", data);

/**
 * 退出登录
 * @param {String} token
 * @returns
 */
export const loginOut = (token) => request.post("/apc/login/out", { "api-token": token });

/**
 * 获取用户信息
 * @returns
 */
export const fetchUserInfo = () => request.get("/apc/user/index");

/**
 * 获取权限列表
 * @returns
 */
export const fetchPermissions = () => request.get("/apc/user/node");

/**
 * 更改版房
 * @param {Number} pattern_room_id 版房id
 */
export const changePatternRoom = (pattern_room_id) => request.post("/apc/login/changePatternRoom", { pattern_room_id });

/**
 * 修改密码
 * @param {Object} params
 * @param {String} params.original_password 旧密码
 * @param {String} params.new_password 新密码
 * @param {String} params.confirm_password 新密码
 */
export const modifyPassword = (params) => request.post("/apc/login/modifyPassword", params);

/**
 * 切换语言
 * @param {Object} params
 * @param {String} params.language_current 语言
 */
export const toggleUserLang = (params) => request.post("/apc/system.account/languageSet", params);
